import { datadogLogs } from '@datadog/browser-logs';
import utils from './utils';

const logger = datadogLogs.logger;

export class CommonLogger {
  static init() {
    const isInitialized = datadogLogs.getInitConfiguration() !== undefined;

    if (isInitialized || utils.isLocalHost()) {
      return;
    }

    const env = utils.getEnvironmentName();

    datadogLogs.init({
      clientToken: 'pubdd60af92f7e28f34ca832dd1e750c8c6',
      site: 'datadoghq.com',
      service: 'mikmak-platform-spa-wrapper',
      env: env,
      forwardErrorsToLogs: true,
      sampleRate: 100,
    });
  }

  static debug(message, messageContext) {
    logger.debug(message, messageContext);
  }

  static info(message, messageContext) {
    logger.info(message, messageContext);
  }

  static warn(message, messageContext) {
    logger.warn(message, messageContext);
  }

  static error(message, messageContext) {
    logger.error(message, messageContext);
  }
}
